import type { RequestResponse } from '@/types/publicType'
import type {
  continentCountryInterface,
  popularInterface,
  liveInterface,
  liveItemInterface,
  countryLiveInterface,
  homeSearchInterface
} from '@/types/apiType/homeType'

/**
 * 获取国家列表
 */
export function apiGetContinentCountryList(): Promise<
  RequestResponse<continentCountryInterface[]>
> {
  return getFetchData({
    url: '/home/get/countryGroup',
    method: 'GET',
    loading: true
  })
}

/**
 * 首页1v1列表
 * @param {number} pageNum
 * @param {number} pageSize
 * @param {string} country
 * @param {string} uid
 * @param {0|3|4} tagNum // 类型 0hot / 3young / 4new
 */
export function apiGetPopularList1(params: {
  pageNum: number
  pageSize: number
  country: string
  uid: string
  tagNum: 0 | 3 | 4
}): Promise<RequestResponse<popularInterface>> {
  return getFetchData({
    url: '/h5/h/popularPage',
    method: 'GET',
    params
  })
}

/**
 * 获取直播列表
 */
export function apiGetLiveList(params: {
  pageNum: number
  pageSize: number
  country: string
  type: number
}): Promise<RequestResponse<liveInterface>> {
  return getFetchData({
    url: '/h5/h/livePage',
    method: 'GET',
    params
  })
}

/**
 * 获取热门直播列表
 */
export function apiGetPopularLive(params: {
  tagNum: 0
  os: ''
  app: string
  appVersion: ''
  pageNum: number
  pageSize: number
}): Promise<RequestResponse<liveInterface>> {
  return getFetchData({
    url: '/h5/h/popular',
    method: 'GET',
    params
  })
}

/**
 * 获取关注直播列表
 */
export function apiGetFollowLive(params: {
  tagNum: 0
  os: ''
  app: string
  appVersion: ''
  pageNum: number
  pageSize: number
}): Promise<RequestResponse<liveItemInterface[]>> {
  return getFetchData({
    url: '/h5/h/getFollow',
    method: 'GET',
    params
  })
}

/**
 * 获取地区直播列表
 */
export function apiGetCountryLive(params: {
  tagNum: 0
  os: ''
  app: string
  appVersion: ''
  pageNum: number
  pageSize: number
}): Promise<RequestResponse<countryLiveInterface>> {
  return getFetchData({
    url: '/h5/h/countryRoom',
    method: 'GET',
    params
  })
}

/**
 * 首页-搜索
 * @param {number} key
 * @param {1 | 2} type
 */
export function apiHomeSearch(params: {
  key: number
  type: 1 | 2
}): Promise<RequestResponse<homeSearchInterface[]>> {
  return getFetchData({
    url: '/h5/h/byType',
    method: 'GET',
    params
  })
}
